import { initializeNeuroGuide } from '../init.js';
import { QuestionTypes as NeuroQuestionTypes } from '../components';
import { conversationTestReducer } from './state';
import ConversationTest, { ConversationTestLoading } from './CTApp';

const init = async ({ messages, questionTypes }) => {
  //Show the detailed messages that print page would show
  Object.keys(messages['en']).forEach((k) => {
    if (messages['en'][`details.${k}`]) {
      messages['en'][k] = messages['en'][`details.${k}`];
    }
  });

  //Override common types with basic question types
  const finalQuestionTypes = {
    ...NeuroQuestionTypes,
    CheckboxIcon: NeuroQuestionTypes.Checkbox,
    CheckboxButton: NeuroQuestionTypes.Checkbox,
    RadioIcon: NeuroQuestionTypes.Radio,
    RadioButton: NeuroQuestionTypes.Radio,
    Slider: NeuroQuestionTypes.Radio,
    DropdownSearch: NeuroQuestionTypes.Dropdown,
    ...questionTypes,
  };

  await initializeNeuroGuide({
    AppComponent: ConversationTest,
    AppLoadingComponent: ConversationTestLoading,
    guideConfig: { questionTypes: finalQuestionTypes },
    messages: messages,
    reducers: [conversationTestReducer],
  });
};

export {
  init as default,
  init as initializeConversationTest
};
